import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CognitoService } from '../../services/cognito.service';
import { AuthService } from '../../services/auth.service';
import { Token } from '../../models/token';
import { AuthError } from 'aws-amplify/auth';
import { NgOtpInputModule } from 'ng-otp-input';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';


@Component({
  selector: 'app-verification',
  standalone: true,
  imports: [NgOtpInputModule, CommonModule],
  templateUrl: './verification.component.html',
})
export class VerificationComponent implements OnInit {

  form = new FormGroup({
    code: new FormControl("", [Validators.required]),
  });
  wrongcode = false;
  loading = false;
  registerInfo: any;

  constructor(public router: Router, public translate: TranslateService, public cognitoService: CognitoService,
    public authService: AuthService, private notificationService: NotificationService, private traslateService: TranslateService) { }
  ngOnInit(): void {
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // OPERATIONAL FUNCTIONS ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  back() {
    this.router.navigateByUrl('/account-login');
  }

  async next() {
    if (this.form.invalid || this.form.controls['code'].value!.length < 6) {
      const title = await this.traslateService.get('NOTIFI.titleWarning').toPromise();
      const detail = await this.traslateService.get(`ERRORS.errorCodeVerification`).toPromise();
      this.notificationService.showWarning(title, detail)
      return;
    }
    this.loading = true;
    try {
      await this.cognitoService.handleSingInConfirmation(this.form.controls['code'].value!);
      const { username, userId, signInDetails } = await this.cognitoService.currentAuthenticatedUser();
      const accessTokenCognito = await this.cognitoService.returnAccesToken();
      localStorage.setItem("Authorization", accessTokenCognito!.toString());
      const token: Token = {
        username: signInDetails?.loginId!,
        accessToken: String(accessTokenCognito)
      }
      const response = await this.insertTokenAsync(token);
      localStorage.setItem("userId", response.userId);
      this.router.navigateByUrl('');
    } catch (error) {
      if (error instanceof AuthError) {
        switch (error.name) {
          case "CodeMismatchException":
            const title = await this.traslateService.get('NOTIFI.titleWarning').toPromise();
            const detail = await this.traslateService.get(`ERRORS.errorCodeInvalid`).toPromise();
            this.notificationService.showWarning(title, detail)
            break
          case "SignInException":
            const titleB = await this.traslateService.get('NOTIFI.titleError').toPromise();
            const detailB = await this.traslateService.get(`ERRORS.loggedContinueError`).toPromise();
            this.notificationService.showWarning(titleB, detailB)
            break
          default:
            const detailC = await this.traslateService.get(`ERRORS.Error`).toPromise();
            this.notificationService.showError(titleB, detailC)
            break
        }
      } else {
        const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
        const detailC = await this.traslateService.get(`ERRORS.Error`).toPromise();
        this.notificationService.showError(title, detailC)
      }
      this.loading = false;
    }
  }

  // Método para convertir el servicio en una Promesa
  insertTokenAsync(token: Token): Promise<any> {
    return new Promise((resolve, reject) => {
      this.authService.insertToken(token).subscribe(
        response => resolve(response),
        error => reject(error)
      );
    });
  }

  onOtpChange(otp: any) {
    this.wrongcode = false;
    this.form.controls['code'].setValue(otp);
  }

}
